import Box from '@totallymoney/ui/components/Box'
import LinkButton from '@totallymoney/ui/components/LinkButton'

import ErrorPage from '@components/ErrorPage'

const ScoredCardError = () => {
    return (
        <ErrorPage
            title="Something went wrong!"
            subtitle="Oops! The credit cards service is unavailable right now."
        >
            <Box pt="space30" maxWidth={['100%', '280px']}>
                <LinkButton variant="primary" text="Try again" href="" />
            </Box>
        </ErrorPage>
    )
}

export default ScoredCardError
